export const countries = [
  {
    name: "American Samoa",
    label: "American Samoa",
    phone: "1684",
    continent: "OC",
    capital: "Pago Pago",
    currency: "USD",
    languages: ["en", "sm"],
    code: "AS",
  },
  {
    name: "Andorra",
    label: "Andorra",
    phone: "376",
    continent: "EU",
    capital: "Andorra la Vella",
    currency: "EUR",
    languages: ["ca"],
    code: "AD",
  },
  {
    name: "Angola",
    label: "Angola",
    phone: "244",
    continent: "AF",
    capital: "Luanda",
    currency: "AOA",
    languages: ["pt"],
    code: "AO",
  },
  {
    name: "Anguilla",
    label: "Anguilla",
    phone: "1264",
    continent: "NA",
    capital: "The Valley",
    currency: "XCD",
    languages: ["en"],
    code: "AI",
  },
  {
    name: "Antarctica",
    label: "Antarctica",
    phone: "672",
    continent: "AN",
    capital: "",
    currency: "",
    languages: [],
    code: "AQ",
  },
  {
    name: "Antigua and Barbuda",
    label: "Antigua and Barbuda",
    phone: "1268",
    continent: "NA",
    capital: "Saint John's",
    currency: "XCD",
    languages: ["en"],
    code: "AG",
  },
  {
    name: "Argentina",
    label: "Argentina",
    phone: "54",
    continent: "SA",
    capital: "Buenos Aires",
    currency: "ARS",
    languages: ["es", "gn"],
    code: "AR",
  },
  {
    name: "Aruba",
    label: "Aruba",
    phone: "297",
    continent: "NA",
    capital: "Oranjestad",
    currency: "AWG",
    languages: ["nl", "pa"],
    code: "AW",
  },
  {
    name: "Australia",
    label: "Australia",
    phone: "61",
    continent: "OC",
    capital: "Canberra",
    currency: "AUD",
    languages: ["en"],
    code: "AU",
  },
  {
    name: "Azerbaijan",
    label: "Azərbaycan",
    phone: "994",
    continent: "AS",
    capital: "Baku",
    currency: "AZN",
    languages: ["az"],
    code: "AZ",
  },
  {
    name: "Bahamas",
    label: "Bahamas",
    phone: "1242",
    continent: "NA",
    capital: "Nassau",
    currency: "BSD",
    languages: ["en"],
    code: "BS",
  },
  {
    name: "Bangladesh",
    label: "Bangladesh",
    phone: "880",
    continent: "AS",
    capital: "Dhaka",
    currency: "BDT",
    languages: ["bn"],
    code: "BD",
  },
  {
    name: "Barbados",
    label: "Barbados",
    phone: "1246",
    continent: "NA",
    capital: "Bridgetown",
    currency: "BBD",
    languages: ["en"],
    code: "BB",
  },
  {
    name: "Belgium",
    label: "België",
    phone: "32",
    continent: "EU",
    capital: "Brussels",
    currency: "EUR",
    languages: ["nl", "fr", "de"],
    code: "BE",
  },
  {
    name: "Belize",
    label: "Belize",
    phone: "501",
    continent: "NA",
    capital: "Belmopan",
    currency: "BZD",
    languages: ["en", "es"],
    code: "BZ",
  },
  {
    name: "Benin",
    label: "Bénin",
    phone: "229",
    continent: "AF",
    capital: "Porto-Novo",
    currency: "XOF",
    languages: ["fr"],
    code: "BJ",
  },
  {
    name: "Bermuda",
    label: "Bermuda",
    phone: "1441",
    continent: "NA",
    capital: "Hamilton",
    currency: "BMD",
    languages: ["en"],
    code: "BM",
  },
  {
    name: "Bosnia and Herzegovina",
    label: "Bosna i Hercegovina",
    phone: "387",
    continent: "EU",
    capital: "Sarajevo",
    currency: "BAM",
    languages: ["bs", "hr", "sr"],
    code: "BA",
  },
  {
    name: "Botswana",
    label: "Botswana",
    phone: "267",
    continent: "AF",
    capital: "Gaborone",
    currency: "BWP",
    languages: ["en", "tn"],
    code: "BW",
  },
  {
    name: "Bouvet Island",
    label: "Bouvetøya",
    phone: "47",
    continent: "AN",
    capital: "",
    currency: "NOK",
    languages: ["no", "nb", "nn"],
    code: "BV",
  },
  {
    name: "Brazil",
    label: "Brasil",
    phone: "55",
    continent: "SA",
    capital: "Brasília",
    currency: "BRL",
    languages: ["pt"],
    code: "BR",
  },
  {
    name: "British Indian Ocean Territory",
    label: "British Indian Ocean Territory",
    phone: "246",
    continent: "AS",
    capital: "Diego Garcia",
    currency: "USD",
    languages: ["en"],
    code: "IO",
  },
  {
    name: "Burkina Faso",
    label: "Burkina Faso",
    phone: "226",
    continent: "AF",
    capital: "Ouagadougou",
    currency: "XOF",
    languages: ["fr", "ff"],
    code: "BF",
  },
  {
    name: "Burundi",
    label: "Burundi",
    phone: "257",
    continent: "AF",
    capital: "Bujumbura",
    currency: "BIF",
    languages: ["fr", "rn"],
    code: "BI",
  },
  {
    name: "Cape Verde",
    label: "Cabo Verde",
    phone: "238",
    continent: "AF",
    capital: "Praia",
    currency: "CVE",
    languages: ["pt"],
    code: "CV",
  },
  {
    name: "Cameroon",
    label: "Cameroon",
    phone: "237",
    continent: "AF",
    capital: "Yaoundé",
    currency: "XAF",
    languages: ["en", "fr"],
    code: "CM",
  },
  {
    name: "Canada",
    label: "Canada",
    phone: "1",
    continent: "NA",
    capital: "Ottawa",
    currency: "CAD",
    languages: ["en", "fr"],
    code: "CA",
  },
  {
    name: "Cayman Islands",
    label: "Cayman Islands",
    phone: "1345",
    continent: "NA",
    capital: "George Town",
    currency: "KYD",
    languages: ["en"],
    code: "KY",
  },
  {
    name: "Czech Republic",
    label: "Česká republika",
    phone: "420",
    continent: "EU",
    capital: "Prague",
    currency: "CZK",
    languages: ["cs", "sk"],
    code: "CZ",
  },
  {
    name: "Chile",
    label: "Chile",
    phone: "56",
    continent: "SA",
    capital: "Santiago",
    currency: "CLF,CLP",
    languages: ["es"],
    code: "CL",
  },
  {
    name: "Christmas Island",
    label: "Christmas Island",
    phone: "61",
    continent: "AS",
    capital: "Flying Fish Cove",
    currency: "AUD",
    languages: ["en"],
    code: "CX",
  },
  {
    name: "Colombia",
    label: "Colombia",
    phone: "57",
    continent: "SA",
    capital: "Bogotá",
    currency: "COP",
    languages: ["es"],
    code: "CO",
  },
  {
    name: "Cook Islands",
    label: "Cook Islands",
    phone: "682",
    continent: "OC",
    capital: "Avarua",
    currency: "NZD",
    languages: ["en"],
    code: "CK",
  },
  {
    name: "Costa Rica",
    label: "Costa Rica",
    phone: "506",
    continent: "NA",
    capital: "San José",
    currency: "CRC",
    languages: ["es"],
    code: "CR",
  },
  {
    name: "Cuba",
    label: "Cuba",
    phone: "53",
    continent: "NA",
    capital: "Havana",
    currency: "CUC,CUP",
    languages: ["es"],
    code: "CU",
  },
  {
    name: "Denmark",
    label: "Danmark",
    phone: "45",
    continent: "EU",
    capital: "Copenhagen",
    currency: "DKK",
    languages: ["da"],
    code: "DK",
  },
  {
    name: "Germany",
    label: "Deutschland",
    phone: "49",
    continent: "EU",
    capital: "Berlin",
    currency: "EUR",
    languages: ["de"],
    code: "DE",
  },
  {
    name: "Djibouti",
    label: "Djibouti",
    phone: "253",
    continent: "AF",
    capital: "Djibouti",
    currency: "DJF",
    languages: ["fr", "ar"],
    code: "DJ",
  },
  {
    name: "Dominica",
    label: "Dominica",
    phone: "1767",
    continent: "NA",
    capital: "Roseau",
    currency: "XCD",
    languages: ["en"],
    code: "DM",
  },
  {
    name: "Ecuador",
    label: "Ecuador",
    phone: "593",
    continent: "SA",
    capital: "Quito",
    currency: "USD",
    languages: ["es"],
    code: "EC",
  },
  {
    name: "Estonia",
    label: "Eesti",
    phone: "372",
    continent: "EU",
    capital: "Tallinn",
    currency: "EUR",
    languages: ["et"],
    code: "EE",
  },
  {
    name: "Ireland",
    label: "Éire",
    phone: "353",
    continent: "EU",
    capital: "Dublin",
    currency: "EUR",
    languages: ["ga", "en"],
    code: "IE",
  },
  {
    name: "El Salvador",
    label: "El Salvador",
    phone: "503",
    continent: "NA",
    capital: "San Salvador",
    currency: "SVC,USD",
    languages: ["es"],
    code: "SV",
  },
  {
    name: "Spain",
    label: "España",
    phone: "34",
    continent: "EU",
    capital: "Madrid",
    currency: "EUR",
    languages: ["es", "eu", "ca", "gl", "oc"],
    code: "ES",
  },
  {
    name: "Fiji",
    label: "Fiji",
    phone: "679",
    continent: "OC",
    capital: "Suva",
    currency: "FJD",
    languages: ["en", "fj", "hi", "ur"],
    code: "FJ",
  },
  {
    name: "Faroe Islands",
    label: "Føroyar",
    phone: "298",
    continent: "EU",
    capital: "Tórshavn",
    currency: "DKK",
    languages: ["fo"],
    code: "FO",
  },
  {
    name: "France",
    label: "France",
    phone: "33",
    continent: "EU",
    capital: "Paris",
    currency: "EUR",
    languages: ["fr"],
    code: "FR",
  },
  {
    name: "Gabon",
    label: "Gabon",
    phone: "241",
    continent: "AF",
    capital: "Libreville",
    currency: "XAF",
    languages: ["fr"],
    code: "GA",
  },
  {
    name: "Gambia",
    label: "Gambia",
    phone: "220",
    continent: "AF",
    capital: "Banjul",
    currency: "GMD",
    languages: ["en"],
    code: "GM",
  },
  {
    name: "Ghana",
    label: "Ghana",
    phone: "233",
    continent: "AF",
    capital: "Accra",
    currency: "GHS",
    languages: ["en"],
    code: "GH",
  },
  {
    name: "Gibraltar",
    label: "Gibraltar",
    phone: "350",
    continent: "EU",
    capital: "Gibraltar",
    currency: "GIP",
    languages: ["en"],
    code: "GI",
  },
  {
    name: "Grenada",
    label: "Grenada",
    phone: "1473",
    continent: "NA",
    capital: "St. George's",
    currency: "XCD",
    languages: ["en"],
    code: "GD",
  },
  {
    name: "Guadeloupe",
    label: "Guadeloupe",
    phone: "590",
    continent: "NA",
    capital: "Basse-Terre",
    currency: "EUR",
    languages: ["fr"],
    code: "GP",
  },
  {
    name: "Guam",
    label: "Guam",
    phone: "1671",
    continent: "OC",
    capital: "Hagåtña",
    currency: "USD",
    languages: ["en", "ch", "es"],
    code: "GU",
  },
  {
    name: "Guatemala",
    label: "Guatemala",
    phone: "502",
    continent: "NA",
    capital: "Guatemala City",
    currency: "GTQ",
    languages: ["es"],
    code: "GT",
  },
  {
    name: "Guernsey",
    label: "Guernsey",
    phone: "44",
    continent: "EU",
    capital: "St. Peter Port",
    currency: "GBP",
    languages: ["en", "fr"],
    code: "GG",
  },
  {
    name: "Guinea-Bissau",
    label: "Guiné-Bissau",
    phone: "245",
    continent: "AF",
    capital: "Bissau",
    currency: "XOF",
    languages: ["pt"],
    code: "GW",
  },
  {
    name: "Equatorial Guinea",
    label: "Guinea Ecuatorial",
    phone: "240",
    continent: "AF",
    capital: "Malabo",
    currency: "XAF",
    languages: ["es", "fr"],
    code: "GQ",
  },
  {
    name: "Guinea",
    label: "Guinée",
    phone: "224",
    continent: "AF",
    capital: "Conakry",
    currency: "GNF",
    languages: ["fr", "ff"],
    code: "GN",
  },
  {
    name: "Guyana",
    label: "Guyana",
    phone: "592",
    continent: "SA",
    capital: "Georgetown",
    currency: "GYD",
    languages: ["en"],
    code: "GY",
  },
  {
    name: "French Guiana",
    label: "Guyane française",
    phone: "594",
    continent: "SA",
    capital: "Cayenne",
    currency: "EUR",
    languages: ["fr"],
    code: "GF",
  },
  {
    name: "Haiti",
    label: "Haïti",
    phone: "509",
    continent: "NA",
    capital: "Port-au-Prince",
    currency: "HTG,USD",
    languages: ["fr", "ht"],
    code: "HT",
  },
  {
    name: "Heard Island and McDonald Islands",
    label: "Heard Island and McDonald Islands",
    phone: "61",
    continent: "AN",
    capital: "",
    currency: "AUD",
    languages: ["en"],
    code: "HM",
  },
  {
    name: "Honduras",
    label: "Honduras",
    phone: "504",
    continent: "NA",
    capital: "Tegucigalpa",
    currency: "HNL",
    languages: ["es"],
    code: "HN",
  },
  {
    name: "Croatia",
    label: "Hrvatska",
    phone: "385",
    continent: "EU",
    capital: "Zagreb",
    currency: "HRK",
    languages: ["hr"],
    code: "HR",
  },
  {
    name: "Indonesia",
    label: "Indonesia",
    phone: "62",
    continent: "AS",
    capital: "Jakarta",
    currency: "IDR",
    languages: ["id"],
    code: "ID",
  },
  {
    name: "Iceland",
    label: "Ísland",
    phone: "354",
    continent: "EU",
    capital: "Reykjavik",
    currency: "ISK",
    languages: ["is"],
    code: "IS",
  },
  {
    name: "Isle of Man",
    label: "Isle of Man",
    phone: "44",
    continent: "EU",
    capital: "Douglas",
    currency: "GBP",
    languages: ["en", "gv"],
    code: "IM",
  },
  {
    name: "Italy",
    label: "Italia",
    phone: "39",
    continent: "EU",
    capital: "Rome",
    currency: "EUR",
    languages: ["it"],
    code: "IT",
  },
  {
    name: "Jamaica",
    label: "Jamaica",
    phone: "1876",
    continent: "NA",
    capital: "Kingston",
    currency: "JMD",
    languages: ["en"],
    code: "JM",
  },
  {
    name: "Jersey",
    label: "Jersey",
    phone: "44",
    continent: "EU",
    capital: "Saint Helier",
    currency: "GBP",
    languages: ["en", "fr"],
    code: "JE",
  },
  {
    name: "Greenland",
    label: "Kalaallit Nunaat",
    phone: "299",
    continent: "NA",
    capital: "Nuuk",
    currency: "DKK",
    languages: ["kl"],
    code: "GL",
  },
  {
    name: "Cambodia",
    label: "Kâmpŭchéa",
    phone: "855",
    continent: "AS",
    capital: "Phnom Penh",
    currency: "KHR",
    languages: ["km"],
    code: "KH",
  },
  {
    name: "Kenya",
    label: "Kenya",
    phone: "254",
    continent: "AF",
    capital: "Nairobi",
    currency: "KES",
    languages: ["en", "sw"],
    code: "KE",
  },
  {
    name: "Kiribati",
    label: "Kiribati",
    phone: "686",
    continent: "OC",
    capital: "South Tarawa",
    currency: "AUD",
    languages: ["en"],
    code: "KI",
  },
  {
    name: "Central African Republic",
    label: "Ködörösêse tî Bêafrîka",
    phone: "236",
    continent: "AF",
    capital: "Bangui",
    currency: "XAF",
    languages: ["fr", "sg"],
    code: "CF",
  },
  {
    name: "Comoros",
    label: "Komori",
    phone: "269",
    continent: "AF",
    capital: "Moroni",
    currency: "KMF",
    languages: ["ar", "fr"],
    code: "KM",
  },
  {
    name: "Réunion",
    label: "La Réunion",
    phone: "262",
    continent: "AF",
    capital: "Saint-Denis",
    currency: "EUR",
    languages: ["fr"],
    code: "RE",
  },
  {
    name: "Latvia",
    label: "Latvija",
    phone: "371",
    continent: "EU",
    capital: "Riga",
    currency: "EUR",
    languages: ["lv"],
    code: "LV",
  },
  {
    name: "Lesotho",
    label: "Lesotho",
    phone: "266",
    continent: "AF",
    capital: "Maseru",
    currency: "LSL,ZAR",
    languages: ["en", "st"],
    code: "LS",
  },
  {
    name: "Liberia",
    label: "Liberia",
    phone: "231",
    continent: "AF",
    capital: "Monrovia",
    currency: "LRD",
    languages: ["en"],
    code: "LR",
  },
  {
    name: "Liechtenstein",
    label: "Liechtenstein",
    phone: "423",
    continent: "EU",
    capital: "Vaduz",
    currency: "CHF",
    languages: ["de"],
    code: "LI",
  },
  {
    name: "Lithuania",
    label: "Lietuva",
    phone: "370",
    continent: "EU",
    capital: "Vilnius",
    currency: "EUR",
    languages: ["lt"],
    code: "LT",
  },
  {
    name: "Luxembourg",
    label: "Luxembourg",
    phone: "352",
    continent: "EU",
    capital: "Luxembourg",
    currency: "EUR",
    languages: ["fr", "de", "lb"],
    code: "LU",
  },
  {
    name: "Madagascar",
    label: "Madagasikara",
    phone: "261",
    continent: "AF",
    capital: "Antananarivo",
    currency: "MGA",
    languages: ["fr", "mg"],
    code: "MG",
  },
  {
    name: "Hungary",
    label: "Magyarország",
    phone: "36",
    continent: "EU",
    capital: "Budapest",
    currency: "HUF",
    languages: ["hu"],
    code: "HU",
  },
  {
    name: "Marshall Islands",
    label: "M̧ajeļ",
    phone: "692",
    continent: "OC",
    capital: "Majuro",
    currency: "USD",
    languages: ["en", "mh"],
    code: "MH",
  },
  {
    name: "Malawi",
    label: "Malawi",
    phone: "265",
    continent: "AF",
    capital: "Lilongwe",
    currency: "MWK",
    languages: ["en", "ny"],
    code: "MW",
  },
  {
    name: "Malaysia",
    label: "Malaysia",
    phone: "60",
    continent: "AS",
    capital: "Kuala Lumpur",
    currency: "MYR",
    languages: ["ms"],
    code: "MY",
  },
  {
    name: "Maldives",
    label: "Maldives",
    phone: "960",
    continent: "AS",
    capital: "Malé",
    currency: "MVR",
    languages: ["dv"],
    code: "MV",
  },
  {
    name: "Mali",
    label: "Mali",
    phone: "223",
    continent: "AF",
    capital: "Bamako",
    currency: "XOF",
    languages: ["fr"],
    code: "ML",
  },
  {
    name: "Malta",
    label: "Malta",
    phone: "356",
    continent: "EU",
    capital: "Valletta",
    currency: "EUR",
    languages: ["mt", "en"],
    code: "MT",
  },
  {
    name: "Martinique",
    label: "Martinique",
    phone: "596",
    continent: "NA",
    capital: "Fort-de-France",
    currency: "EUR",
    languages: ["fr"],
    code: "MQ",
  },
  {
    name: "Mauritius",
    label: "Maurice",
    phone: "230",
    continent: "AF",
    capital: "Port Louis",
    currency: "MUR",
    languages: ["en"],
    code: "MU",
  },
  {
    name: "Mayotte",
    label: "Mayotte",
    phone: "262",
    continent: "AF",
    capital: "Mamoudzou",
    currency: "EUR",
    languages: ["fr"],
    code: "YT",
  },
  {
    name: "Mexico",
    label: "México",
    phone: "52",
    continent: "NA",
    capital: "Mexico City",
    currency: "MXN",
    languages: ["es"],
    code: "MX",
  },

  {
    name: "Mozambique",
    label: "Moçambique",
    phone: "258",
    continent: "AF",
    capital: "Maputo",
    currency: "MZN",
    languages: ["pt"],
    code: "MZ",
  },
  {
    name: "Monaco",
    label: "Monaco",
    phone: "377",
    continent: "EU",
    capital: "Monaco",
    currency: "EUR",
    languages: ["fr"],
    code: "MC",
  },
  {
    name: "Montserrat",
    label: "Montserrat",
    phone: "1664",
    continent: "NA",
    capital: "Plymouth",
    currency: "XCD",
    languages: ["en"],
    code: "MS",
  },
  {
    name: "Namibia",
    label: "Namibia",
    phone: "264",
    continent: "AF",
    capital: "Windhoek",
    currency: "NAD,ZAR",
    languages: ["en", "af"],
    code: "NA",
  },
  {
    name: "Nauru",
    label: "Nauru",
    phone: "674",
    continent: "OC",
    capital: "Yaren",
    currency: "AUD",
    languages: ["en", "na"],
    code: "NR",
  },
  {
    name: "Netherlands",
    label: "Nederland",
    phone: "31",
    continent: "EU",
    capital: "Amsterdam",
    currency: "EUR",
    languages: ["nl"],
    code: "NL",
  },
  {
    name: "New Zealand",
    label: "New Zealand",
    phone: "64",
    continent: "OC",
    capital: "Wellington",
    currency: "NZD",
    languages: ["en", "mi"],
    code: "NZ",
  },
  {
    name: "Nicaragua",
    label: "Nicaragua",
    phone: "505",
    continent: "NA",
    capital: "Managua",
    currency: "NIO",
    languages: ["es"],
    code: "NI",
  },
  {
    name: "Niger",
    label: "Niger",
    phone: "227",
    continent: "AF",
    capital: "Niamey",
    currency: "XOF",
    languages: ["fr"],
    code: "NE",
  },
  {
    name: "Nigeria",
    label: "Nigeria",
    phone: "234",
    continent: "AF",
    capital: "Abuja",
    currency: "NGN",
    languages: ["en"],
    code: "NG",
  },
  {
    name: "Niue",
    label: "Niuē",
    phone: "683",
    continent: "OC",
    capital: "Alofi",
    currency: "NZD",
    languages: ["en"],
    code: "NU",
  },
  {
    name: "Norfolk Island",
    label: "Norfolk Island",
    phone: "672",
    continent: "OC",
    capital: "Kingston",
    currency: "AUD",
    languages: ["en"],
    code: "NF",
  },
  {
    name: "Norway",
    label: "Norge",
    phone: "47",
    continent: "EU",
    capital: "Oslo",
    currency: "NOK",
    languages: ["no", "nb", "nn"],
    code: "NO",
  },
  {
    name: "Northern Mariana Islands",
    label: "Northern Mariana Islands",
    phone: "1670",
    continent: "OC",
    capital: "Saipan",
    currency: "USD",
    languages: ["en", "ch"],
    code: "MP",
  },
  {
    name: "New Caledonia",
    label: "Nouvelle-Calédonie",
    phone: "687",
    continent: "OC",
    capital: "Nouméa",
    currency: "XPF",
    languages: ["fr"],
    code: "NC",
  },
  {
    name: "Uzbekistan",
    label: "O‘zbekiston",
    phone: "998",
    continent: "AS",
    capital: "Tashkent",
    currency: "UZS",
    languages: ["uz", "ru"],
    code: "UZ",
  },
  {
    name: "Austria",
    label: "Österreich",
    phone: "43",
    continent: "EU",
    capital: "Vienna",
    currency: "EUR",
    languages: ["de"],
    code: "AT",
  },
  {
    name: "Pakistan",
    label: "Pakistan",
    phone: "92",
    continent: "AS",
    capital: "Islamabad",
    currency: "PKR",
    languages: ["en", "ur"],
    code: "PK",
  },
  {
    name: "Palau",
    label: "Palau",
    phone: "680",
    continent: "OC",
    capital: "Ngerulmud",
    currency: "USD",
    languages: ["en"],
    code: "PW",
  },
  {
    name: "Panama",
    label: "Panamá",
    phone: "507",
    continent: "NA",
    capital: "Panama City",
    currency: "PAB,USD",
    languages: ["es"],
    code: "PA",
  },
  {
    name: "Papua New Guinea",
    label: "Papua Niugini",
    phone: "675",
    continent: "OC",
    capital: "Port Moresby",
    currency: "PGK",
    languages: ["en"],
    code: "PG",
  },
  {
    name: "Paraguay",
    label: "Paraguay",
    phone: "595",
    continent: "SA",
    capital: "Asunción",
    currency: "PYG",
    languages: ["es", "gn"],
    code: "PY",
  },
  {
    name: "Peru",
    label: "Perú",
    phone: "51",
    continent: "SA",
    capital: "Lima",
    currency: "PEN",
    languages: ["es"],
    code: "PE",
  },
  {
    name: "Philippines",
    label: "Pilipinas",
    phone: "63",
    continent: "AS",
    capital: "Manila",
    currency: "PHP",
    languages: ["en"],
    code: "PH",
  },
  {
    name: "Poland",
    label: "Polska",
    phone: "48",
    continent: "EU",
    capital: "Warsaw",
    currency: "PLN",
    languages: ["pl"],
    code: "PL",
  },
  {
    name: "French Polynesia",
    label: "Polynésie française",
    phone: "689",
    continent: "OC",
    capital: "Papeetē",
    currency: "XPF",
    languages: ["fr"],
    code: "PF",
  },
  {
    name: "Portugal",
    label: "Portugal",
    phone: "351",
    continent: "EU",
    capital: "Lisbon",
    currency: "EUR",
    languages: ["pt"],
    code: "PT",
  },
  {
    name: "Puerto Rico",
    label: "Puerto Rico",
    phone: "1787,1939",
    continent: "NA",
    capital: "San Juan",
    currency: "USD",
    languages: ["es", "en"],
    code: "PR",
  },
  {
    name: "Dominican Republic",
    label: "República Dominicana",
    phone: "1809,1829,1849",
    continent: "NA",
    capital: "Santo Domingo",
    currency: "DOP",
    languages: ["es"],
    code: "DO",
  },
  {
    name: "Romania",
    label: "România",
    phone: "40",
    continent: "EU",
    capital: "Bucharest",
    currency: "RON",
    languages: ["ro"],
    code: "RO",
  },
  {
    name: "Rwanda",
    label: "Rwanda",
    phone: "250",
    continent: "AF",
    capital: "Kigali",
    currency: "RWF",
    languages: ["rw", "en", "fr"],
    code: "RW",
  },
  {
    name: "Saint Kitts and Nevis",
    label: "Saint Kitts and Nevis",
    phone: "1869",
    continent: "NA",
    capital: "Basseterre",
    currency: "XCD",
    languages: ["en"],
    code: "KN",
  },
  {
    name: "Saint Lucia",
    label: "Saint Lucia",
    phone: "1758",
    continent: "NA",
    capital: "Castries",
    currency: "XCD",
    languages: ["en"],
    code: "LC",
  },
  {
    name: "Saint Vincent and the Grenadines",
    label: "Saint Vincent and the Grenadines",
    phone: "1784",
    continent: "NA",
    capital: "Kingstown",
    currency: "XCD",
    languages: ["en"],
    code: "VC",
  },
  {
    name: "Saint Barthélemy",
    label: "Saint-Barthélemy",
    phone: "590",
    continent: "NA",
    capital: "Gustavia",
    currency: "EUR",
    languages: ["fr"],
    code: "BL",
  },
  {
    name: "Saint Pierre and Miquelon",
    label: "Saint-Pierre-et-Miquelon",
    phone: "508",
    continent: "NA",
    capital: "Saint-Pierre",
    currency: "EUR",
    languages: ["fr"],
    code: "PM",
  },
  {
    name: "Samoa",
    label: "Samoa",
    phone: "685",
    continent: "OC",
    capital: "Apia",
    currency: "WST",
    languages: ["sm", "en"],
    code: "WS",
  },
  {
    name: "San Marino",
    label: "San Marino",
    phone: "378",
    continent: "EU",
    capital: "City of San Marino",
    currency: "EUR",
    languages: ["it"],
    code: "SM",
  },
  {
    name: "Switzerland",
    label: "Schweiz",
    phone: "41",
    continent: "EU",
    capital: "Bern",
    currency: "CHE,CHF,CHW",
    languages: ["de", "fr", "it"],
    code: "CH",
  },
  {
    name: "Senegal",
    label: "Sénégal",
    phone: "221",
    continent: "AF",
    capital: "Dakar",
    currency: "XOF",
    languages: ["fr"],
    code: "SN",
  },
  {
    name: "Seychelles",
    label: "Seychelles",
    phone: "248",
    continent: "AF",
    capital: "Victoria",
    currency: "SCR",
    languages: ["fr", "en"],
    code: "SC",
  },
  {
    name: "Albania",
    label: "Shqipëria",
    phone: "355",
    continent: "EU",
    capital: "Tirana",
    currency: "ALL",
    languages: ["sq"],
    code: "AL",
  },
  {
    name: "Sierra Leone",
    label: "Sierra Leone",
    phone: "232",
    continent: "AF",
    capital: "Freetown",
    currency: "SLL",
    languages: ["en"],
    code: "SL",
  },
  {
    name: "Singapore",
    label: "Singapore",
    phone: "65",
    continent: "AS",
    capital: "Singapore",
    currency: "SGD",
    languages: ["en", "ms", "ta", "zh"],
    code: "SG",
  },
  {
    name: "Slovenia",
    label: "Slovenija",
    phone: "386",
    continent: "EU",
    capital: "Ljubljana",
    currency: "EUR",
    languages: ["sl"],
    code: "SI",
  },
  {
    name: "Slovakia",
    label: "Slovensko",
    phone: "421",
    continent: "EU",
    capital: "Bratislava",
    currency: "EUR",
    languages: ["sk"],
    code: "SK",
  },
  {
    name: "Solomon Islands",
    label: "Solomon Islands",
    phone: "677",
    continent: "OC",
    capital: "Honiara",
    currency: "SBD",
    languages: ["en"],
    code: "SB",
  },
  {
    name: "Somalia",
    label: "Soomaaliya",
    phone: "252",
    continent: "AF",
    capital: "Mogadishu",
    currency: "SOS",
    languages: ["so", "ar"],
    code: "SO",
  },
  {
    name: "South Africa",
    label: "South Africa",
    phone: "27",
    continent: "AF",
    capital: "Pretoria",
    currency: "ZAR",
    languages: ["af", "en", "nr", "st", "ss", "tn", "ts", "ve", "xh", "zu"],
    code: "ZA",
  },
  {
    name: "South Georgia and the South Sandwich Islands",
    label: "South Georgia",
    phone: "500",
    continent: "AN",
    capital: "King Edward Point",
    currency: "GBP",
    languages: ["en"],
    code: "GS",
  },
  {
    name: "South Sudan",
    label: "South Sudan",
    phone: "211",
    continent: "AF",
    capital: "Juba",
    currency: "SSP",
    languages: ["en"],
    code: "SS",
  },
  {
    name: "Sri Lanka",
    label: "śrī laṃkāva",
    phone: "94",
    continent: "AS",
    capital: "Colombo",
    currency: "LKR",
    languages: ["si", "ta"],
    code: "LK",
  },
  {
    name: "Finland",
    label: "Suomi",
    phone: "358",
    continent: "EU",
    capital: "Helsinki",
    currency: "EUR",
    languages: ["fi", "sv"],
    code: "FI",
  },
  {
    name: "Suriname",
    label: "Suriname",
    phone: "597",
    continent: "SA",
    capital: "Paramaribo",
    currency: "SRD",
    languages: ["nl"],
    code: "SR",
  },
  {
    name: "Svalbard and Jan Mayen",
    label: "Svalbard og Jan Mayen",
    phone: "4779",
    continent: "EU",
    capital: "Longyearbyen",
    currency: "NOK",
    languages: ["no"],
    code: "SJ",
  },
  {
    name: "Sweden",
    label: "Sverige",
    phone: "46",
    continent: "EU",
    capital: "Stockholm",
    currency: "SEK",
    languages: ["sv"],
    code: "SE",
  },
  {
    name: "Swaziland",
    label: "Swaziland",
    phone: "268",
    continent: "AF",
    capital: "Lobamba",
    currency: "SZL",
    languages: ["en", "ss"],
    code: "SZ",
  },
  {
    name: "Chad",
    label: "Tchad",
    phone: "235",
    continent: "AF",
    capital: "N'Djamena",
    currency: "XAF",
    languages: ["fr", "ar"],
    code: "TD",
  },
  {
    name: "French Southern Territories",
    label: "Territoire des Terres australes et antarctiques fr",
    phone: "262",
    continent: "AN",
    capital: "Port-aux-Français",
    currency: "EUR",
    languages: ["fr"],
    code: "TF",
  },
  {
    name: "Togo",
    label: "Togo",
    phone: "228",
    continent: "AF",
    capital: "Lomé",
    currency: "XOF",
    languages: ["fr"],
    code: "TG",
  },
  {
    name: "Tokelau",
    label: "Tokelau",
    phone: "690",
    continent: "OC",
    capital: "Fakaofo",
    currency: "NZD",
    languages: ["en"],
    code: "TK",
  },
  {
    name: "Tonga",
    label: "Tonga",
    phone: "676",
    continent: "OC",
    capital: "Nuku'alofa",
    currency: "TOP",
    languages: ["en", "to"],
    code: "TO",
  },
  {
    name: "Trinidad and Tobago",
    label: "Trinidad and Tobago",
    phone: "1868",
    continent: "NA",
    capital: "Port of Spain",
    currency: "TTD",
    languages: ["en"],
    code: "TT",
  },
  {
    name: "Turkey",
    label: "Türkiye",
    phone: "90",
    continent: "AS",
    capital: "Ankara",
    currency: "TRY",
    languages: ["tr"],
    code: "TR",
  },
  {
    name: "Turkmenistan",
    label: "Türkmenistan",
    phone: "993",
    continent: "AS",
    capital: "Ashgabat",
    currency: "TMT",
    languages: ["tk", "ru"],
    code: "TM",
  },
  {
    name: "Turks and Caicos Islands",
    label: "Turks and Caicos Islands",
    phone: "1649",
    continent: "NA",
    capital: "Cockburn Town",
    currency: "USD",
    languages: ["en"],
    code: "TC",
  },
  {
    name: "Tuvalu",
    label: "Tuvalu",
    phone: "688",
    continent: "OC",
    capital: "Funafuti",
    currency: "AUD",
    languages: ["en"],
    code: "TV",
  },
  {
    name: "Uganda",
    label: "Uganda",
    phone: "256",
    continent: "AF",
    capital: "Kampala",
    currency: "UGX",
    languages: ["en", "sw"],
    code: "UG",
  },
  {
    name: "United Kingdom",
    label: "United Kingdom",
    phone: "44",
    continent: "EU",
    capital: "London",
    currency: "GBP",
    languages: ["en"],
    code: "GB",
  },
  {
    name: "United States",
    label: "United States",
    phone: "1",
    continent: "NA",
    capital: "Washington D.C.",
    currency: "USD,USN,USS",
    languages: ["en"],
    code: "US",
  },
  {
    name: "Uruguay",
    label: "Uruguay",
    phone: "598",
    continent: "SA",
    capital: "Montevideo",
    currency: "UYI,UYU",
    languages: ["es"],
    code: "UY",
  },
  {
    name: "Vanuatu",
    label: "Vanuatu",
    phone: "678",
    continent: "OC",
    capital: "Port Vila",
    currency: "VUV",
    languages: ["bi", "en", "fr"],
    code: "VU",
  },
  {
    name: "Venezuela",
    label: "Venezuela",
    phone: "58",
    continent: "SA",
    capital: "Caracas",
    currency: "VES",
    languages: ["es"],
    code: "VE",
  },
  {
    name: "Vietnam",
    label: "Việt Nam",
    phone: "84",
    continent: "AS",
    capital: "Hanoi",
    currency: "VND",
    languages: ["vi"],
    code: "VN",
  },
  {
    name: "Wallis and Futuna",
    label: "Wallis et Futuna",
    phone: "681",
    continent: "OC",
    capital: "Mata-Utu",
    currency: "XPF",
    languages: ["fr"],
    code: "WF",
  },
  {
    name: "Zambia",
    label: "Zambia",
    phone: "260",
    continent: "AF",
    capital: "Lusaka",
    currency: "ZMW",
    languages: ["en"],
    code: "ZM",
  },
  {
    name: "Zimbabwe",
    label: "Zimbabwe",
    phone: "263",
    continent: "AF",
    capital: "Harare",
    currency: "USD,ZAR,BWP,GBP,AUD,CNY,INR,JPY",
    languages: ["en", "sn", "nd"],
    code: "ZW",
  },
  {
    name: "Bhutan",
    label: "ʼbrug-yul",
    phone: "975",
    continent: "AS",
    capital: "Thimphu",
    currency: "BTN,INR",
    languages: ["dz"],
    code: "BT",
  },
  {
    name: "Greece",
    label: "Ελλάδα",
    phone: "30",
    continent: "EU",
    capital: "Athens",
    currency: "EUR",
    languages: ["el"],
    code: "GR",
  },
  {
    name: "Cyprus",
    label: "Κύπρος",
    phone: "357",
    continent: "EU",
    capital: "Nicosia",
    currency: "EUR",
    languages: ["el", "tr", "hy"],
    code: "CY",
  },
  {
    name: "Belarus",
    label: "Белару́сь",
    phone: "375",
    continent: "EU",
    capital: "Minsk",
    currency: "BYN",
    languages: ["be", "ru"],
    code: "BY",
  },
  {
    name: "Bulgaria",
    label: "България",
    phone: "359",
    continent: "EU",
    capital: "Sofia",
    currency: "BGN",
    languages: ["bg"],
    code: "BG",
  },
  {
    name: "Kyrgyzstan",
    label: "Кыргызстан",
    phone: "996",
    continent: "AS",
    capital: "Bishkek",
    currency: "KGS",
    languages: ["ky", "ru"],
    code: "KG",
  },
  {
    name: "Kazakhstan",
    label: "Қазақстан",
    phone: "76,77",
    continent: "AS",
    capital: "Astana",
    currency: "KZT",
    languages: ["kk", "ru"],
    code: "KZ",
  },
  {
    name: "Mongolia",
    label: "Монгол улс",
    phone: "976",
    continent: "AS",
    capital: "Ulan Bator",
    currency: "MNT",
    languages: ["mn"],
    code: "MN",
  },
  {
    name: "Russia",
    label: "Россия",
    phone: "7",
    continent: "EU",
    capital: "Moscow",
    currency: "RUB",
    languages: ["ru"],
    code: "RU",
  },
  {
    name: "Serbia",
    label: "Србија",
    phone: "381",
    continent: "EU",
    capital: "Belgrade",
    currency: "RSD",
    languages: ["sr"],
    code: "RS",
  },
  {
    name: "Tajikistan",
    label: "Тоҷикистон",
    phone: "992",
    continent: "AS",
    capital: "Dushanbe",
    currency: "TJS",
    languages: ["tg", "ru"],
    code: "TJ",
  },
  {
    name: "Ukraine",
    label: "Україна",
    phone: "380",
    continent: "EU",
    capital: "Kyiv",
    currency: "UAH",
    languages: ["uk"],
    code: "UA",
  },
  {
    name: "Montenegro",
    label: "Црна Гора",
    phone: "382",
    continent: "EU",
    capital: "Podgorica",
    currency: "EUR",
    languages: ["sr", "bs", "sq", "hr"],
    code: "ME",
  },
  {
    name: "Georgia",
    label: "საქართველო",
    phone: "995",
    continent: "AS",
    capital: "Tbilisi",
    currency: "GEL",
    languages: ["ka"],
    code: "GE",
  },
  {
    name: "Armenia",
    label: "Հայաստան",
    phone: "374",
    continent: "AS",
    capital: "Yerevan",
    currency: "AMD",
    languages: ["hy", "ru"],
    code: "AM",
  },
  {
    name: "Israel",
    label: "יִשְׂרָאֵל",
    phone: "972",
    continent: "AS",
    capital: "Jerusalem",
    currency: "ILS",
    languages: ["he", "ar"],
    code: "IL",
  },
  {
    name: "Afghanistan",
    label: "افغانستان",
    phone: "93",
    continent: "AS",
    capital: "Kabul",
    currency: "AFN",
    languages: ["ps", "uz", "tk"],
    code: "AF",
  },
  {
    name: "Jordan",
    label: "الأردن",
    phone: "962",
    continent: "AS",
    capital: "Amman",
    currency: "JOD",
    languages: ["ar"],
    code: "JO",
  },
  {
    name: "Bahrain",
    label: "‏البحرين",
    phone: "973",
    continent: "AS",
    capital: "Manama",
    currency: "BHD",
    languages: ["ar"],
    code: "BH",
  },
  {
    name: "Algeria",
    label: "الجزائر",
    phone: "213",
    continent: "AF",
    capital: "Algiers",
    currency: "DZD",
    languages: ["ar"],
    code: "DZ",
  },
  {
    name: "Sudan",
    label: "السودان",
    phone: "249",
    continent: "AF",
    capital: "Khartoum",
    currency: "SDG",
    languages: ["ar", "en"],
    code: "SD",
  },
  {
    name: "Western Sahara",
    label: "الصحراء الغربية",
    phone: "212",
    continent: "AF",
    capital: "El Aaiún",
    currency: "MAD,DZD,MRU",
    languages: ["es"],
    code: "EH",
  },
  {
    name: "Iraq",
    label: "العراق",
    phone: "964",
    continent: "AS",
    capital: "Baghdad",
    currency: "IQD",
    languages: ["ar", "ku"],
    code: "IQ",
  },
  {
    name: "Saudi Arabia",
    label: "العربية السعودية",
    phone: "966",
    continent: "AS",
    capital: "Riyadh",
    currency: "SAR",
    languages: ["ar"],
    code: "SA",
  },
  {
    name: "Kuwait",
    label: "الكويت",
    phone: "965",
    continent: "AS",
    capital: "Kuwait City",
    currency: "KWD",
    languages: ["ar"],
    code: "KW",
  },
  {
    name: "Morocco",
    label: "المغرب",
    phone: "212",
    continent: "AF",
    capital: "Rabat",
    currency: "MAD",
    languages: ["ar"],
    code: "MA",
  },
  {
    name: "Yemen",
    label: "اليَمَن",
    phone: "967",
    continent: "AS",
    capital: "Sana'a",
    currency: "YER",
    languages: ["ar"],
    code: "YE",
  },
  {
    name: "Iran",
    label: "ایران",
    phone: "98",
    continent: "AS",
    capital: "Tehran",
    currency: "IRR",
    languages: ["fa"],
    code: "IR",
  },
  {
    name: "Tunisia",
    label: "تونس",
    phone: "216",
    continent: "AF",
    capital: "Tunis",
    currency: "TND",
    languages: ["ar"],
    code: "TN",
  },
  {
    name: "United Arab Emirates",
    label: "دولة الإمارات العربية المتحدة",
    phone: "971",
    continent: "AS",
    capital: "Abu Dhabi",
    currency: "AED",
    languages: ["ar"],
    code: "AE",
  },
  {
    name: "Syria",
    label: "سوريا",
    phone: "963",
    continent: "AS",
    capital: "Damascus",
    currency: "SYP",
    languages: ["ar"],
    code: "SY",
  },
  {
    name: "Oman",
    label: "عمان",
    phone: "968",
    continent: "AS",
    capital: "Muscat",
    currency: "OMR",
    languages: ["ar"],
    code: "OM",
  },
  {
    name: "Palestine",
    label: "فلسطين",
    phone: "970",
    continent: "AS",
    capital: "Ramallah",
    currency: "ILS",
    languages: ["ar"],
    code: "PS",
  },
  {
    name: "Qatar",
    label: "قطر",
    phone: "974",
    continent: "AS",
    capital: "Doha",
    currency: "QAR",
    languages: ["ar"],
    code: "QA",
  },
  {
    name: "Lebanon",
    label: "لبنان",
    phone: "961",
    continent: "AS",
    capital: "Beirut",
    currency: "LBP",
    languages: ["ar", "fr"],
    code: "LB",
  },
  {
    name: "Libya",
    label: "‏ليبيا",
    phone: "218",
    continent: "AF",
    capital: "Tripoli",
    currency: "LYD",
    languages: ["ar"],
    code: "LY",
  },
  {
    name: "Egypt",
    label: "مصر‎",
    phone: "20",
    continent: "AF",
    capital: "Cairo",
    currency: "EGP",
    languages: ["ar"],
    code: "EG",
  },
  {
    name: "Mauritania",
    label: "موريتانيا",
    phone: "222",
    continent: "AF",
    capital: "Nouakchott",
    currency: "MRU",
    languages: ["ar"],
    code: "MR",
  },
  {
    name: "Ethiopia",
    label: "ኢትዮጵያ",
    phone: "251",
    continent: "AF",
    capital: "Addis Ababa",
    currency: "ETB",
    languages: ["am"],
    code: "ET",
  },
  {
    name: "Eritrea",
    label: "ኤርትራ",
    phone: "291",
    continent: "AF",
    capital: "Asmara",
    currency: "ERN",
    languages: ["ti", "ar", "en"],
    code: "ER",
  },
  {
    name: "Nepal",
    label: "नपल",
    phone: "977",
    continent: "AS",
    capital: "Kathmandu",
    currency: "NPR",
    languages: ["ne"],
    code: "NP",
  },
  {
    name: "India",
    label: "भारत",
    phone: "91",
    continent: "AS",
    capital: "New Delhi",
    currency: "INR",
    languages: ["hi", "en"],
    code: "IN",
  },
  {
    name: "Thailand",
    label: "ประเทศไทย",
    phone: "66",
    continent: "AS",
    capital: "Bangkok",
    currency: "THB",
    languages: ["th"],
    code: "TH",
  },
  {
    name: "Myanmar [Burma]",
    label: "မြန်မာ",
    phone: "95",
    continent: "AS",
    capital: "Naypyidaw",
    currency: "MMK",
    languages: ["my"],
    code: "MM",
  },
  {
    name: "South Korea",
    label: "대한민국",
    phone: "82",
    continent: "AS",
    capital: "Seoul",
    currency: "KRW",
    languages: ["ko"],
    code: "KR",
  },
  {
    name: "North Korea",
    label: "북한",
    phone: "850",
    continent: "AS",
    capital: "Pyongyang",
    currency: "KPW",
    languages: ["ko"],
    code: "KP",
  },
  {
    name: "China",
    label: "中国",
    phone: "86",
    continent: "AS",
    capital: "Beijing",
    currency: "CNY",
    languages: ["zh"],
    code: "CN",
  },
  {
    name: "Japan",
    label: "日本",
    phone: "81",
    continent: "AS",
    capital: "Tokyo",
    currency: "JPY",
    languages: ["ja"],
    code: "JP",
  },
  {
    name: "Macao",
    label: "澳門",
    phone: "853",
    continent: "AS",
    capital: "",
    currency: "MOP",
    languages: ["zh", "pt"],
    code: "MO",
  },
  {
    name: "Taiwan",
    label: "臺灣",
    phone: "886",
    continent: "AS",
    capital: "Taipei",
    currency: "TWD",
    languages: ["zh"],
    code: "TW",
  },
  {
    name: "Hong Kong",
    label: "香港",
    phone: "852",
    continent: "AS",
    capital: "City of Victoria",
    currency: "HKD",
    languages: ["zh", "en"],
    code: "HK",
  },
];
